import { type IconProps } from '@atlaskit/icon/types';

import { type BaseAIAction } from '@atlassian/ai-smart-button-api';

import {
	type ConversationAction,
	HandleActionType,
} from '@confluence/conversation-assistant/entry-points/conversation-assistant.ts';

export const mapActionsToConversationActions = (
	baseActions: BaseAIAction[],
): ConversationAction[] => {
	return baseActions.map((action) => ({
		id: action.id,
		title: action.title,
		icon: (_: IconProps) => action.icon,
		description: typeof action.description === 'string' ? action.description : undefined,
		onClick: action.onClick ?? undefined,
		viewConfig: action.viewConfig ?? undefined,
		children: action.children ? mapActionsToConversationActions(action.children) : undefined,
		closePanelOnSelection: action.closePanelOnSelection ?? undefined,
		ref: action.ref ?? undefined,
		type: action.type ?? undefined,
		handleType: getHandleType(action),
	}));
};

const getHandleType = (action: BaseAIAction): HandleActionType => {
	if (action.children) {
		return HandleActionType.Nested;
	} else if (action.type === 'convo-starter-action') {
		return HandleActionType.Chat;
	} else {
		return HandleActionType.Base;
	}
};
